import {
  FullscreenContainer,
  Video,
  VideoOverlay,
  VideoControls,
} from '@mc/video'
import { PlayOverlay } from './PlayOverlay'

type Props = {
  mediaUuid: string
  className?: string
}

export const VideoContainer = ({ mediaUuid, className }: Props) => (
  <div
    className={`mc-theme-light mc-corners--md mc-border--default mc-overflow--hidden ${className}`}
  >
    <FullscreenContainer>
      <div className='mc-w-100 mc-h-100'>
        <Video mediaUuid={mediaUuid}>
          <VideoOverlay state={['paused', 'idle', 'ended']} fade>
            <PlayOverlay />
            <VideoControls />
          </VideoOverlay>
        </Video>
      </div>
    </FullscreenContainer>
  </div>
)
